// Coarse IP-based location guess for first-run defaults. City-level accuracy
// is all that's needed (the user refines with the map or GPS); anything that
// fails — offline, ad blocker, rate limit, slow response — resolves to null
// and the caller keeps its fallback.

export async function guessIPLocation() {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), 4000);
  try {
    const res = await fetch('https://ipapi.co/json/', { signal: ctrl.signal });
    if (!res.ok) return null;
    const j = await res.json();
    if (typeof j.latitude !== 'number' || typeof j.longitude !== 'number') return null;
    return { lat: j.latitude, lon: j.longitude, city: j.city || null };
  } catch {
    return null;
  } finally {
    clearTimeout(t);
  }
}
